export const DEFAULT_LAYOUT = "default-layout";
export const SETTINGS_LAYOUT = "settings-layout";
